'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import {
  useLegalInformationModal,
  LegalInformationPreview,
} from '~/components/elements/legal/LegalInformationModal';

const FooterWidgets = () => {
  const [openWidget, setOpenWidget] = useState(null);
  const { openLegalInformation, legalInformationModal } =
    useLegalInformationModal();

  const toggleWidget = (index) => {
    setOpenWidget(openWidget === index ? null : index);
  };

  return (
    <div className="ps-footer__widgets-wrapper">
      <div className="ps-footer__widget-container">
        <aside className="widget widget_footer widget_contact-us">
          <h3
            className={`widget-title ${openWidget === 0 ? 'open' : ''}`}
            onClick={() => toggleWidget(0)}
          >
            Kontakt
            <i className={`icon-arrow ${openWidget === 0 ? 'open' : ''}`} />
          </h3>
          <div className={`widget_content ${openWidget === 0 ? 'open' : ''}`}>
            <a className="ps-logo" href="/">
              <img src="/static/img/logo_light.png" alt="Rawento Logo" style={{ marginTop: '10px', marginBottom: '10px', height: '40px', width: 'auto' }} suppressHydrationWarning />
            </a>
            <p>
              Im Jagdfeld 53, Erftstadt, Deutschland <br />
              E-Mail: <a href="mailto:info@rawento.com">info@rawento.com</a>
            </p>
            <div className="footer-social-icons" style={{display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap'}}>
              <a href="https://www.facebook.com/profile.php?id=61591536856123" target="_blank" rel="noopener noreferrer"><img src="https://rawento.com/static/services/facebook.png" alt="Facebook" width="28" style={{display: 'block'}} suppressHydrationWarning /></a>
              <a href="https://x.com/rawentocom" target="_blank" rel="noopener noreferrer"><img src="https://rawento.com/static/services/twitter.png" alt="Twitter" width="28" style={{display: 'block'}} suppressHydrationWarning /></a>
              <a href="https://www.youtube.com/@rawentocom" target="_blank" rel="noopener noreferrer"><img src="https://rawento.com/static/services/youtube.png" alt="YouTube" width="28" style={{display: 'block'}} suppressHydrationWarning /></a>
              <a href="https://www.linkedin.com/company/rawento" target="_blank" rel="noopener noreferrer"><img src="https://rawento.com/static/services/linkedin.png" alt="LinkedIn" width="28" style={{display: 'block'}} suppressHydrationWarning /></a>
              <a href="https://www.instagram.com/rawentocom" target="_blank" rel="noopener noreferrer"><img src="https://rawento.com/static/services/instagram.png" alt="Instagram" width="28" style={{display: 'block'}} suppressHydrationWarning /></a>
              <a href="https://www.tiktok.com/@rawentocom" target="_blank" rel="noopener noreferrer"><img src="https://rawento.com/static/services/tiktok.png" alt="TikTok" width="28" style={{display: 'block'}} suppressHydrationWarning /></a>
              <a href="https://www.pinterest.de/rawentocom" target="_blank" rel="noopener noreferrer"><img src="https://rawento.com/static/services/pinterest.png" alt="Pinterest" width="28" style={{display: 'block'}} suppressHydrationWarning /></a>
            </div>
          </div>
        </aside>
      </div>

      <div className="ps-footer__widget-container">
        <aside className="widget widget_footer">
          <h3
            className={`widget-title ${openWidget === 1 ? 'open' : ''}`}
            onClick={() => toggleWidget(1)}
          >
            <Link href="https://rawento.com/customer-service">Kundenservice</Link>
            <i className={`icon-arrow ${openWidget === 1 ? 'open' : ''}`} />
          </h3>
          <ul className={`ps-list--link ${openWidget === 1 ? 'open' : ''}`}>
            <li><Link href="/customer-service/login">Kunden-Login</Link></li>
            <li><Link href="/customer-service/shipping-and-payment-terms">Versand und Zahlungsbedingungen</Link></li>
            <li><Link href="/customer-service/order-tracking">Status meiner Bestellungen</Link></li>
            <li><Link href="/customer-service/invoices">Alle meine Bestellungen und Rechnungen</Link></li>
            <li><Link href="/customer-service/newsletter-signup">Newsletteranmeldung</Link></li>
            <li><Link href="/customer-service/gift-vouchers">Geschenkgutscheine</Link></li>
            <li><Link href="/customer-service/reviews">Bewertungen</Link></li>
            <li><Link href="/customer-service/waste-disposal">Altgeräte- und Batterieentsorgung</Link></li>
            <li><Link href="/customer-service/returns-complaints">Rücksendung & Reklamation</Link></li>
            <li><Link href="/customer-service/contact-us">Kontakt</Link></li>
            <li><Link href="/customer-service/contract-withdrawal" className="cs-footer-highlight">Jetzt widerrufen</Link></li>
          </ul>
        </aside>
      </div>

      <div className="ps-footer__widget-container">
        <aside className="widget widget_footer">
          <h3
            className={`widget-title ${openWidget === 2 ? 'open' : ''}`}
            onClick={() => toggleWidget(2)}
          >
            <Link href="https://rawento.com/company">Unternehmen</Link>
            <i className={`icon-arrow ${openWidget === 2 ? 'open' : ''}`} />
          </h3>
          <ul className={`ps-list--link ${openWidget === 2 ? 'open' : ''}`}>
            <li><Link href="/company/about-us">Über Rawento</Link></li>
            <li><Link href="/company/brand">Unsere Marken</Link></li>
            <li><Link href="/company/cookie">Cookie Einstellungen</Link></li>
            <li><Link href="/company/agbs">Allgemeine Geschäftsbedingungen</Link></li>
            <li><Link href="/company/datenschutz">Datenschutz</Link></li>
            <li><Link href="/company/data-retention">Datenspeicherung</Link></li>
            <li><Link href="/company/widerrufsbelehrungen">Widerrufsbelehrungen</Link></li>
            <li><Link href="/company/streitbeilegung">Streitbeilegung</Link></li>
            <li><Link href="/company/impressum">Impressum</Link></li>
          </ul>
        </aside>
      </div>

      <div className="ps-footer__widget-container">
        <aside className="widget widget_footer">
          <h3
            className={`widget-title ${openWidget === 3 ? 'open' : ''}`}
            onClick={() => toggleWidget(3)}
          >
            <Link href="https://rawento.com/business">Business</Link>
            <i className={`icon-arrow ${openWidget === 3 ? 'open' : ''}`} />
          </h3>
          <ul className={`ps-list--link ${openWidget === 3 ? 'open' : ''}`}>
            <li><Link href="/business/business-login">Geschäftskunden-Login</Link></li>
            <li><Link href="/business/affiliate-program">Affiliate-Programm</Link></li>
            <li><Link href="/business/become-a-vendor">Händler werden</Link></li>
          </ul>

          <div className={`footer-legal-info ${openWidget === 3 ? 'open' : ''}`}>
            <LegalInformationPreview onOpen={openLegalInformation} width={160} />
          </div>
        </aside>
      </div>

      {legalInformationModal}

      <style jsx>{`
        .ps-footer__widgets-wrapper {
          display: flex;
          flex-wrap: nowrap;
          gap: 30px;
          justify-content: space-between;
          align-items: flex-start;
        }
        .ps-footer__widget-container {
          flex: 1 1 0;
          min-width: 0;
          box-sizing: border-box;
        }
        .widget-title {
          font-size: 1.2em;
          font-weight: bold;
          padding: 10px;
          margin: 0px 0;
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          white-space: nowrap;
        }
        .widget-title :global(a) {
          color: inherit;
          text-decoration: none;
          font-size: inherit;
          font-weight: inherit;
          font-family: inherit;
          letter-spacing: inherit;
        }
        .widget_content,
        .ps-list--link {
          padding-left: 20px;
          display: block;
        }
        .footer-legal-info {
          display: flex;
          justify-content: flex-start;
          padding: 20px 20px 20px 20px;
        }
        .ps-list--link :global(.cs-footer-highlight) {
          color: #bf0000 !important;
        }
        .ps-list--link :global(.cs-footer-highlight:hover) {
          color: #bf0000 !important;
          text-decoration: underline;
        }

        /* Wenn die vier Spalten nicht mehr nebeneinander passen:
           statt Umbruch -> mobile Ansicht (untereinander, eingeklappt) */
        @media (max-width: 1024px) {
          .ps-footer__widgets-wrapper {
            flex-direction: column;
            flex-wrap: nowrap;
            gap: 0px;
            align-items: stretch;
          }
          .ps-footer__widget-container {
            flex: 0 0 auto;
            margin-bottom: 0px;
            min-width: auto;
          }
          .widget-title {
            cursor: pointer;
            display: flex;
            align-items: center;
            border-bottom: 1px solid rgb(204, 204, 204);
          }
          .widget_content,
          .ps-list--link,
          .footer-legal-info {
            display: none;
          }
          .widget-title.open + .widget_content,
          .widget-title.open + .ps-list--link {
            display: block;
          }
          .widget-title.open ~ .footer-legal-info.open {
            display: flex;
          }
          .icon-arrow {
            content: '';
            display: inline-block;
            width: 30px;
            height: 30px;
            background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"%3E%3Cpath d="M16 18.838a.674.674 0 0 1-.478-.198l-4.325-4.324a.676.676 0 0 1 .957-.956L16 17.207l3.846-3.847a.676.676 0 1 1 .957.956l-4.325 4.324a.674.674 0 0 1-.478.198Z"%3E%3C/path%3E%3C/svg%3E');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            transition: transform 0.3s ease;
            margin-left: 10px;
          }
          .icon-arrow.open {
            transform: rotate(180deg);
          }
        }
      `}</style>
    </div>
  );
};

export default FooterWidgets;